var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagonLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lock",
    transform: "translate(-3203 -161)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Layer1",
    "data-name": "Ellipse 284",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(3203 166)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Layer2",
    "data-name": "Ellipse 283",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(3203 161)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Lock",
    "data-name": "lock",
    d: "M10.678,5.98h-.641V4.058a4.058,4.058,0,1,0-8.116,0V5.98H1.281A1.282,1.282,0,0,0,0,7.261v5.126a1.282,1.282,0,0,0,1.281,1.281h9.4a1.282,1.282,0,0,0,1.281-1.281V7.261A1.282,1.282,0,0,0,10.678,5.98ZM7.9,5.98H4.058V4.058a1.922,1.922,0,1,1,3.844,0Z",
    transform: "translate(3213 170.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonLock);
export default __webpack_public_path__ + "static/media/HexagonLock.56ab62b0.svg";
export { ForwardRef as ReactComponent };